import InputUpload from '@app/components/atoms/Images/InputUpload'
import LabelField from '@app/components/atoms/LabelField/LabelField'
import Section from '@app/components/atoms/Section/Section'
import { FORM_COLOR } from '@app/constant/ColorDefault'
import { toTextFieldDateFormat } from '@app/libs/format'
import BasicInformationSection from '@app/modules/Merchant/Voucher/VoucherCreate/BasicInformationSection'
import CodeSection from '@app/modules/Merchant/Voucher/VoucherCreate/CodeSection'
import POSSection from '@app/modules/Merchant/Voucher/VoucherCreate/POSSection'
import validationSchema from '@app/modules/Merchant/Voucher/VoucherCreate/Schema'
import TermAndConditionSection from '@app/modules/Merchant/Voucher/VoucherCreate/TermAndConditionSection'
import { yupResolver } from '@hookform/resolvers/yup'
import { Inertia } from '@inertiajs/inertia'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const VoucherCreate = ({ categories, pos, voucherType, tags }) => {
  const { t } = useTranslation()
  const [disableBtn, setDisableBtn] = useState(false)

  const initialValues = {
    name: '',
    merchant: '',
    categories: [],
    price: '',
    quantity: '',
    info_link: '',
    tags: [],
    pos: [],
    term: '',
    description: '',
    condition: '',
    how_to_use: '',
    images: [],
    merchant_id: 0,
    type: 'standard',
    limit_min: '',
    limit_max: '',
    limit_code_per_user: 0,
    expired_date: toTextFieldDateFormat(new Date()),
  }

  const data = {
    tags,
  }

  const onSubmit = (data) => {
    setDisableBtn(true)
    Inertia.post(route('merchant.vouchers.store'), data, {})
  }

  Inertia.on('finish', () => setDisableBtn(false))

  const onError = (errors, e) => {}

  const {
    register,
    trigger,
    control,
    handleSubmit,
    getValues,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  })

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <Grid container spacing={2} sx={{ pt: '10px' }}>
        <Grid item xs={12}>
          <Section title={t('VOUCHER.BASIC_INFORMATION')}>
            <Grid container>
              <Grid item lg={7} xs={12}>
                <BasicInformationSection
                  categories={categories}
                  control={control}
                  data={data}
                  errors={errors}
                  getValues={getValues}
                  register={register}
                  setValue={setValue}
                  trigger={trigger}
                />
              </Grid>
            </Grid>
          </Section>
        </Grid>

        <Grid item xs={12}>
          <Section title={t('VOUCHER.CODES')}>
            <Grid container>
              <Grid item lg={7} xs={12}>
                <CodeSection
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  register={register}
                  setValue={setValue}
                  voucherType={voucherType}
                />
              </Grid>
            </Grid>
          </Section>
        </Grid>

        <Grid item xs={12}>
          <Section title={t('VOUCHER.TERM_AND_CONDITION')}>
            <Grid container>
              <Grid item lg={7} xs={12}>
                <TermAndConditionSection
                  control={control}
                  getValues={getValues}
                  register={register}
                  setValue={setValue}
                />
              </Grid>
            </Grid>
          </Section>
        </Grid>

        <Grid item xs={12}>
          <Section title={t('VOUCHER.POS')}>
            <Grid container>
              <Grid item lg={7} xs={12}>
                <POSSection
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  pos={pos}
                  setValue={setValue}
                  trigger={trigger}
                />
              </Grid>
            </Grid>
          </Section>
        </Grid>

        <Grid item xs={12}>
          <Section title={t('VOUCHER.IMAGE')}>
            <Grid container>
              <Grid item lg={7} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <LabelField required recommend={t('VOUCHER.SLIDER_RECOMMEND')} title={t('VOUCHER.SLIDER')}>
                      <Controller
                        control={control}
                        name="images"
                        render={({ field }) => (
                          <InputUpload
                            {...field}
                            multiple
                            buttonName={t('VOUCHER.UPLOAD_IMAGE')}
                            clearErrors={clearErrors}
                            handleImageChange={(files) => setValue('images', files)}
                            id="images"
                            name="images"
                            ref={field.ref}
                            setError={setError}
                            title={t('VOUCHER.UPLOAD_IMAGE')}
                            value={getValues('images')}
                          />
                        )}
                      />

                      {errors.images && (
                        <Typography sx={{ color: FORM_COLOR.REQUIRED_ERROR, pl: '14px' }} variant="caption">
                          {errors.images?.message}
                        </Typography>
                      )}
                    </LabelField>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Section>
        </Grid>

        <Grid item xs={12}>
          <Button color="primary" disabled={disableBtn} sx={{ mr: 2 }} type="submit" variant="contained">
            {t('BUTTON.SAVE')}
          </Button>
          <Button color="inherit" href={route('merchant.vouchers.index')} variant="contained">
            {t('BUTTON.CANCEL')}
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default VoucherCreate
